export default class ProductCardHelper {
  constructor() {
    this.offersListSelector = '_offers-control__list';
    this.inputQuantity = '_quantity-input';
    this.sizeCheckbox = 'filter-size__checkbox';
    this.quantyIdSelector = 'data-quantity';
    this.sQuantityAttr = 'quantity';
    this.quantityBtn = '_quantity-btn';
    this.quantityDecreaseBtn = '_quantity-decrease';
    this.quantityIncreaseBtn = '_quantity-increase';
    this.quantityTotalSelector = '_quantity-total';
    this.iRadix = 10;

    this.iDelayBeforeRequest = 200;
    this.obTimer = null;
  }

  initAutoUpdateQuantity() {
    const form = document.querySelector(`.${this.offersListSelector}`);
    if (form) {
      const checkbox = form.querySelectorAll('input[type=radio]');
      checkbox.forEach((el) => {
        if (el.checked) {
          const quantity = el.getAttribute(this.quantyIdSelector);
          $(`.${this.inputQuantity}`)
            .attr('max', quantity)
            .val(1);
          $(`.${this.quantityTotalSelector}`)
            .html(quantity);
          this.setBtnDisabled();
        }
      });
    }
  }

  initUpdateQuantity() {
    this.initAutoUpdateQuantity();
    $('body')
      .on('click', `.${this.sizeCheckbox}`, ({ target }) => {
        const quantity = target.getAttribute(this.quantyIdSelector);

        $(`.${this.inputQuantity}`)
          .attr('max', quantity)
          .val(1);
        $(`.${this.quantityTotalSelector}`)
          .html(quantity);
        this.setBtnDisabled();
      });
  }

  initUpdateButton() {
    $('body')
      .on('click', `.${this.quantityDecreaseBtn}`, (obEvent) => {
        const { currentTarget: obButton } = obEvent;
        this.initDecrease(obButton);
      });
    $('body')
      .on('click', `.${this.quantityIncreaseBtn}`, (obEvent) => {
        const { currentTarget: obButton } = obEvent;
        this.initIncrease(obButton);
      });
  }

  initDecrease(obButton) {
    if (this.obTimer !== null) {
      clearTimeout(this.obTimer);
    }

    this.obTimer = setTimeout(() => {
      const quantityInput = this.getQuantityInput();
      let iQuantity = this.getQuantity(quantityInput) - 1;

      this.removeBtnDisabled();
      if (iQuantity < 1) {
        iQuantity = 1;
      }

      if (iQuantity === 1) {
        obButton.setAttribute('disabled', 'disabled');
      } else {
        obButton.removeAttribute('disabled');
      }

      $(`.${this.inputQuantity}`)
        .val(iQuantity);
    }, this.iDelayBeforeRequest);
  }

  initIncrease(obButton) {
    if (this.obTimer !== null) {
      clearTimeout(this.obTimer);
    }
    this.obTimer = setTimeout(() => {
      this.removeBtnDisabled();
      const quantityInput = this.getQuantityInput();
      const iMaxQuantity = this.getMaxQuantity(quantityInput);
      let iQuantity = this.getQuantity(quantityInput) + 1;

      if (iQuantity === iMaxQuantity) {
        iQuantity = iMaxQuantity;
        obButton.setAttribute('disabled', 'disabled');
      } else {
        obButton.removeAttribute('disabled');
      }

      $(`.${this.inputQuantity}`)
        .val(iQuantity);
    }, this.iDelayBeforeRequest);
  }

  getQuantityInput() {
    return document.querySelector(`.${this.inputQuantity}`);
  }

  getQuantity(quantityInput) {
    return parseInt(quantityInput.value, this.iRadix);
  }

  getMaxQuantity(quantityInput) {
    return parseInt(quantityInput.getAttribute('max'), this.iRadix);
  }

  setBtnDisabled() {
    const quantityInput = this.getQuantityInput();
    const iMaxQuantity = this.getMaxQuantity(quantityInput);

    const obIncreaseButton = document.querySelector(`.${this.quantityIncreaseBtn}`);
    if (iMaxQuantity === 1) {
      obIncreaseButton.setAttribute('disabled', 'disabled');
    } else {
      obIncreaseButton.removeAttribute('disabled');
    }
  }

  removeBtnDisabled() {
    const buttons = document.querySelectorAll(`.${this.quantityBtn}`);
    if (!buttons) return;
    buttons.forEach((button) => {
      button.removeAttribute('disabled');
    });
  }

  checkSelectOffer() {
    const form = document.querySelector(`.${this.offersListSelector}`);
    if (!form) {
      // eslint-disable-next-line no-console
      console.error('Не указан список с размерами');
      return false;
    }

    const checkboxFiles = form.querySelectorAll('input[type=radio]');
    const empty = [].filter.call(checkboxFiles, el => !el.checked);
    if (checkboxFiles.length === empty.length) {
      return false;
    }
    return true;
  }
}
